const app = angular.module('msi.shipping', [
  require('./modal'),
  require('./add-shipping'),
  require('./select-shipping'),
  require('./shipping.service')
]);

module.exports = app.name;
